const scrollIntoView = el => {
    let top = el.getBoundingClientRect().top + pageYOffset;

    window.scrollTo({
        top: top - 100,
        behavior: 'smooth'
    });
}

export { scrollIntoView };